import styled from "styled-components";

type ContainerType = {
    background: string;
    border: string;
};

type IconOpsType = {
    color: string;
}


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Content = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  background: ${props => props.background};
  border-radius: 5px;
  width: 100%;
  max-width: 768px;
  border: 1px solid ${props => props.border};
`;

export const ContentInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

`;
export const ContentInputBorder = styled.div`
  display: flex;
  flex-direction: column;
  height: 70px;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 768px;
  width: 100%;
`;

